// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"0877a6d4665f2e19c0c4","339":"1a345be52931f57d1e72"}[chunkId] + ".js";
};